<template lang="pug">
section.i_ptb_10
  .container
    .slider_banner.i_plr_8.i_ptb_6.d-flex.flex-column.flex-md-row
      svg-icon.swiper-prev.d-md-none(
        iconClass="arrow_left_mobile",
        className="icon",
        @click="prevClick"
      )

      .banner.d-none.d-md-block
        .img(
          v-if="bannerList",
          :style="{ backgroundImage: 'url(' + bannerList[bannerIndex].area01_BannerList_ImagePC + ')' }"
        )
      .slider_content.d-flex.flex-column.justify-content-around.i_ml_sm_0.i_ml_12
        swiper.swiper-container(:options="swiperOption", ref="mySwiper")
          swiper-slide.swiper-slide(
            v-for="(sliderContent, index) in bannerList",
            :key="index"
          )
            .head_wrapper.d-flex.align-items-center
              .banner.d-md-none
                .img(
                  :style="{ backgroundImage: 'url(' + sliderContent.area01_BannerList_ImagePC + ')' }"
                )
              h2.i_h2_title {{ sliderContent.area01_BannerList_Title }}
            p.i_body_l.i_mt_4(v-html="sliderContent.area01_BannerList_Content")
            a(:href="sliderContent.area01_BannerList_URL", target="_blank")
              .btn_square.btn_yellow.i_mt_8 瞭解更多
        div(style="width: 100%")
          .swiper-pagination.d-none.d-md-block(slot="pagination")

      svg-icon.swiper-next.d-md-none(
        iconClass="arrow_right_mobile",
        className="icon",
        @click="nextClick"
      )
</template>

<script>
export default {
  name: "SliderBanner",
  props: {
    bannerList: Array,
  },
  data() {
    var self = this;
    return {
      swiperOption: {
        notNextTick: true,
        initialSlide: 0,
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        direction: "horizontal",
        grabCursor: false,
        setWrapperSize: true,
        autoHeight: false,
        mousewheelControl: true,
        observeParents: true,
        debugger: true,
        paginationClickable: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          slideChangeTransitionStart: function () {
            self.bannerIndex = this.realIndex;
          },
        },
      },
      bannerIndex: 0,
    };
  },
  computed: {
    sliderBannerSwiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  methods: {
    prevClick() {
      this.sliderBannerSwiper.slidePrev();
    },
    nextClick() {
      this.sliderBannerSwiper.slideNext();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/home/slider_banner";
</style>
